import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { DoorVisitTableFooter } from './DoorVisitTableFooter';
import type { DoorVisitListItem } from './useDoorVisitList';

export type { DoorVisitListItem };

export type DoorVisitTableProps = {
  items: DoorVisitListItem[];
  total: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  onRowClick: (doorVisitId: number) => void;
};

export const DoorVisitTable = ({
  items,
  total,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onRowClick,
}: DoorVisitTableProps) => (
  <Box data-testid="door-visit-table">
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Voter Name</TableCell>
            <TableCell>Predicted Address</TableCell>
            {/* Summary column truncates to one line — AI summaries are unbounded in length */}
            <TableCell sx={{ width: '50%' }}>Summary</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(item => (
            <TableRow
              key={item.doorVisitId}
              hover
              sx={{ cursor: 'pointer' }}
              onClick={() => onRowClick(item.doorVisitId)}
            >
              <TableCell>{item.voterName ?? '–'}</TableCell>
              <TableCell>{item.address ?? '–'}</TableCell>
              <TableCell
                sx={{
                  maxWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.conversationSummary ?? '–'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <DoorVisitTableFooter
      total={total}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  </Box>
);
